import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImgLoaderService {

  private images: string[] = [
    'icons/grid-forms/1x2.png',
    'icons/grid-forms/1x2-active.png',
    'icons/grid-forms/2x1.png',
    'icons/grid-forms/2x1-active.png',
    'icons/grid-forms/2x2.png',
    'icons/grid-forms/2x2-active.png',
    'icons/grid-forms/2x3.png',
    'icons/grid-forms/2x3-active.png',
    'icons/grid-forms/3x2.png',
    'icons/grid-forms/3x2-active.png',
    'icons/grid-forms/3x3.png',
    'icons/grid-forms/3x3-active.png',
    'icons/grid-forms/5x2.png',
    'icons/grid-forms/5x2-active.png',
  ];

  public loadImages(): void {
    for (const image of this.images) {
      let img: HTMLImageElement = new Image();
      img.src = './' + image;
    }
  }
}
